module.exports = __webpack_public_path__ + "ptc_nakagawa_E2.b00654e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_E2.jpg
// module id = ueAv
// module chunks = 0